const activityStatuses = {
  STARTED: 'STARTED',
  COMPLETED: 'COMPLETED',
  PROCESSING: 'PROCESSING'
};

export default activityStatuses;